var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mx-2",attrs:{"color":_vm.color,"disabled":_vm.disabled},on:{"click":_vm.downloadResultCSV}},[_vm._v(_vm._s(_vm.labels.EXPORT_RESULT_CSV)),_c('v-icon',[_vm._v("mdi-download")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }